<script>
import TableList from '@/components/TableList.vue'
import * as components from './TableList/'
export default {
  extends: TableList,
  components,
  mounted() {
    this.$util.event.listener('api.get-order', this.getOrder)
  },
  unmounted() {
    this.$util.event.remove('api.get-order', this.getOrder)
  },
  methods: {
    getOrder({ detail }) {
      let id = String(detail.id) || null
      if (!id) {
        return {}
      }
      let data = this.store.getter('rows', {})
      let order = {}
      for (const [, object] of Object.entries(data)) {
        if (String(object._id) == id) {
          order = _.cloneDeep(object)
          order = Object.assign({}, order, order.information)
          delete order.information
          delete order.alerts
          delete order.actions
          break
        }
      }
      this.$util.event.create('api.get-order-callback', {
        status: 'sussess',
        data: order
      })
    }
  }
}
</script>
<style lang="scss">
table.order,
table.sub-order {
  .column-cb {
    input {
      margin: 5px 0;
    }
  }
  .column-information {
    width: 350px;
    max-width: 350px;
    .tracking-id ul {
      list-style-type: circle;
      padding-left: 30px;
      margin-bottom: 5px;
      label {
        text-transform: uppercase;
        padding: 0;
        margin: 0;
      }
    }
  }
  label {
    padding-right: 5px;
    margin-bottom: 5px;
  }
  .item-line-item {
    label {
      margin-bottom: 0;
    }
  }
  .flag {
    margin-top: 5px;
  }
}

.buyer-info {
  border: 1px dashed #ccc;
  padding: 10px 15px;
  border-radius: 10px;
  margin: 5px 0;
  position: relative;

  .more-actions {
    position: absolute;
    right: 8px;
    top: 8px;
    font-size: 16px;
    user-select: none;
    display: flex;
    .print-content {
      display: none;
    }
  }
  &:hover {
    .more-actions .print-content {
      display: flex;
    }
  }
  .print-content {
    cursor: pointer;
  }
  .flag {
    font-size: 16px;
    color: transparent;
    cursor: default;
    user-select: none;
    &.yellow {
      color: rgba(255, 207, 0, 1);
    }
    &.orange {
      color: rgba(255, 165, 0, 1);
    }
    &.red {
      color: rgba(255, 0, 0, 1);
    }
    &.purple {
      color: rgba(128, 0, 128, 1);
    }
    &.green {
      color: rgba(0, 128, 0, 1);
    }
    &.blue {
      color: rgba(0, 0, 255, 1);
    }
  }
  .name,
  .first-line,
  .second-line,
  .country {
    display: block;
  }
  .city,
  .state {
    &:after {
      content: '-';
      display: inline-block;
      padding: 0 5px;
    }
  }
  .zip {
    text-transform: uppercase;
  }
}
.order-note {
  font-size: 13px;
  font-style: italic;
  color: #4caf50;
  text-align: justify;
  &:empty {
    display: none;
  }
}

.list-line-items {
  margin: 0;
  list-style: none;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  > li {
    width: 100%;
  }
  .item-line-item {
    padding: 5px 0px 15px 0px;
    float: left;
    display: flex;
    flex-wrap: wrap;
    position: relative;
    border-bottom: 1px solid #ccc;
    &:first-child {
      padding-top: 0;
    }
    &:last-child {
      padding-bottom: 0;
      border-bottom: 0;
    }
  }
  .line-item-thumbnail {
    position: relative;
    width: 200px;
    height: 200px;
    float: left;
    margin-right: 15px;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    i {
      display: none;
      font-size: 20px;
      position: absolute;
      right: 10px;
      bottom: 10px;
      color: #00ff37 !important;
      background: #fff;
      border-radius: 50%;
    }
    &.designed {
      i {
        display: block;
      }
    }
  }
  .line-item-main {
    flex: 1;
    display: flex;
    flex-wrap: wrap;
  }
  .line-item-summary {
    min-width: 250px;
    margin-right: 20px;
  }
  .line-item-title {
    font-weight: bold;
    margin-bottom: 10px;
    width: 100%;
    padding-right: 20px;
  }
  .line-item-meta {
    min-width: 250px;
    p {
      margin-bottom: 0;
    }
    ul {
      padding-left: 17px;
    }
  }
  .currency {
    text-transform: uppercase;
    padding-left: 3px;
  }
}
</style>
